import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import NewsRequest from '../../../RunPay/Admin/IServices/Models/News/NewsRequest';
import SaveNewsRequest from '../../../RunPay/Admin/IServices/Models/SaveNewsRequest';
import WsResponseModel from '../../../SchemaBuilderServer/Models/WsResponseModel';
import PaginationResponse from '../../../Common/ResponseModels/PaginationResponse';
import NewsItemResponse from '../../../RunPay/Admin/IServices/Models/News/NewsItemResponse';
import BaseResponse from '../../../Common/ResponseModels/BaseResponse';

export default class NewsService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModel<PaginationResponse<NewsItemResponse>>>();
	SaveEvent = new Events<WsResponseModel<BaseResponse>>();
	DeleteEvent = new Events<WsResponseModel<BaseResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('NewsService', 'GetList', (res: WsResponseModel<PaginationResponse<NewsItemResponse>>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('NewsService', 'Save', (res: WsResponseModel<BaseResponse>) => {
			self.SaveEvent.trigger(res);
		});
		webApiService.on('NewsService', 'Delete', (res: WsResponseModel<BaseResponse>) => {
			self.DeleteEvent.trigger(res);
		});
	}
	GetList(request: NewsRequest = null) { 	
        this.webApiService.send('NewsService', 'GetList' , request);
    }
	Save(request: SaveNewsRequest = null) { 	
        this.webApiService.send('NewsService', 'Save' , request);
    }
	Delete(id: number = 0) { 	
        this.webApiService.send('NewsService', 'Delete' , id);
    }
	 // async methods
	async getListAsync(request: NewsRequest = null): Promise<PaginationResponse<NewsItemResponse>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async saveAsync(request: SaveNewsRequest = null): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Save.bind(this), this.SaveEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<BaseResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
}


// WEBPACK FOOTER //
// ./scripts/dataSource/api/RunPay/Admin/Services/NewsService.ts